import { render, staticRenderFns } from "./FooterLegal.vue?vue&type=template&id=2b208870&scoped=true&"
import script from "./FooterLegal.vue?vue&type=script&lang=js&"
export * from "./FooterLegal.vue?vue&type=script&lang=js&"
import style0 from "./FooterLegal.vue?vue&type=style&index=0&id=2b208870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b208870",
  null
  
)

export default component.exports